import { CountryCode } from '../../../gql-operations/gql-generated';
import { SELLER_PROFILE_IMAGE_WC_WINNER_ARGENTINA, SELLER_PROFILE_IMAGE_WC_WINNER_SPAIN } from './constants';

interface GetWorldCupWinnerBadgeImageUrlParams {
    countryCode?: CountryCode | string | null;
    isArgentinaWorldCupWinnerRolloutActive?: boolean;
    isSpainWorldCupWinnerRolloutActive?: boolean;
}

export const getWorldCupWinnerBadgeImageUrl = ({
    countryCode,
    isArgentinaWorldCupWinnerRolloutActive,
    isSpainWorldCupWinnerRolloutActive,
}: GetWorldCupWinnerBadgeImageUrlParams): string | undefined => {
    if (countryCode === CountryCode.Ar && isArgentinaWorldCupWinnerRolloutActive) {
        return SELLER_PROFILE_IMAGE_WC_WINNER_ARGENTINA;
    }

    if (countryCode === CountryCode.Es && isSpainWorldCupWinnerRolloutActive) {
        return SELLER_PROFILE_IMAGE_WC_WINNER_SPAIN;
    }

    return undefined;
};
